import { API_ENDPOINT } from '../../config'
import { FeatureSwitchMap } from '../../utils/features/featureSwitches'
import customFetch from '../../utils/customFetch'
import { FlowMetaData } from '../../@types/types'

const buildQueryString = (params: Record<string, string | undefined>) => {
  const queryParams = Object.entries(params)
    .filter(([_, value]) => value !== undefined)
    .map(([key, value]) => `${key}=${encodeURIComponent(value!)}`)
    .join('&')
  return queryParams ? `?${queryParams}` : ''
}

/**
 * URL construction examples:
 * Without flow metadata: https://api.immobilien.de/anbieten/private-anbieter/inserieren/api/configurations
 * With flow metadata: https://api.immobilien.de/anbieten/private-anbieter/inserieren/api/configurations?category=APARTMENT&transaction=RENT&segmentation=PROPERTY_OWNER
 */
const url = (flowMetadata?: FlowMetaData) =>
  API_ENDPOINT +
  '/anbieten/private-anbieter/inserieren/api/configurations' +
  buildQueryString((flowMetadata || {}) as Record<string, string | undefined>)

export const loadFeatures = async (flowMetadata?: FlowMetaData): Promise<FeatureSwitchMap> => {
  const options = {
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: 'include',
  }
  const response = await customFetch(url(flowMetadata), options)
  if (response.status != 200) {
    throw new Error(`Cannot load features, failed with ${response.status} and message ${await response.text()}`)
  }
  return (await response.json()) as FeatureSwitchMap
}
